import { AppLayout } from '../components/UI/AppLayout/AppLayout'

export const VisitsPage = () => {
    return <AppLayout />
}
